import { createCn } from 'cn/config';

export const cn = createCn({
  extend: {
    theme: {
      text: ['badge', 'ui', 'prose', 'message', 'meta', 'heading', 'title'],
    },
  },
});
